import React from 'react';
import { useIntlBds } from '../../../../../translations/BdsIntlProvider';
import { Input } from '../../../../Form/Input';
import { Icon } from '../../../../Icon';
import { IconButton } from '../../../../IconButton';
import { dataTableClassnames } from '../../const/classNames';
import { useDataTableContext } from '../../context/DataTableContext';
import { useFilterState } from '../../utils/useFilterState';

export const Search: React.FC = () => {
  const { intl } = useIntlBds();
  const { slotProps } = useDataTableContext();
  const { setQueryModel, queryModel } = useFilterState();

  const searchProps =
    typeof slotProps?.toolbar?.search === 'boolean'
      ? {
          placeholder: intl.DataTable.SearchInput.placeholder,
          dataTest: dataTableClassnames.header.searchInput
        }
      : typeof slotProps?.toolbar?.search === 'object'
        ? {
            placeholder: slotProps?.toolbar?.search?.placeholder ?? intl.DataTable.SearchInput.placeholder,
            dataTest: slotProps?.toolbar?.search?.dataTest ?? dataTableClassnames.header.searchInput
          }
        : undefined;

  const handleSearch = (search: string) => {
    setQueryModel('search', search);
  };

  if (!searchProps) {
    return null;
  }

  return (
    <Input
      sx={{ width: 220 }}
      value={queryModel.search || ''}
      onChange={({ target }) => {
        handleSearch(target.value);
      }}
      startAdornment={<Icon alt="search" name="search" />}
      endAdornment={
        queryModel.search ? (
          <IconButton
            size="small"
            dataTest="clear-search-btn"
            onClick={() => {
              handleSearch('');
            }}
            iconName="close"
          />
        ) : undefined
      }
      {...searchProps}
      id={dataTableClassnames.header.searchInput}
    />
  );
};
